export function redirectByDevice() {
  const isMobile = /Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent);
  const currentUrl = window.location.href;
  // 拆分 URL
  const origin = window.location.origin; // 例如 http://192.168.10.103:8080
  let pathname = window.location.pathname; // 例如 /about 或 /m/about

  // 如果是移动端访问 PC 页面
  if (isMobile && !pathname.startsWith('/m')) {
    // 加上 /m/
    const newUrl = `${origin}/m${pathname}`;
    window.location.replace(newUrl);
  }

  // 如果是 PC 访问移动端页面
  if (!isMobile && pathname.startsWith('/m')) {
    // 去掉 /m/
    const newUrl = `${origin}${pathname.replace(/^\/m/, '')}`;
    window.location.replace(newUrl);
  }
}
